const galleryData = {
  study_1_smile: {
    title: "Expressive Portrait Workshop",
    description: ""
  },
  study_2_3h_p: {
    title: "3 Hour Portrait Study",
    description: ""
  },
  study_3_3h_p: {
    title: "3 Hour Portrait Study",
    description: ""
  },
  study_4_snake: {
    title: "Figure Study",
    description: ""
  },
  study_5_f: {
    title: "Figure Study",
    description: ""
  }
};

export default galleryData; 